import React from 'react';
import { FadeIn } from './FadeIn';
import { AlertCircle, Users, Clock } from 'lucide-react';
export function Urgency() {
  return <section className="w-full py-16 px-6 bg-amber-light/20 border-y border-amber-light/50" data-id="element-358">
      <div className="max-w-4xl mx-auto" data-id="element-359">
        <FadeIn data-id="element-360">
          <div className="flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-361">
            <div className="flex-1 space-y-4 text-center md:text-left" data-id="element-362">
              <div className="inline-flex items-center gap-2 bg-amber text-charcoal font-bold px-4 py-1.5 rounded-full text-sm uppercase tracking-wider" data-id="element-363">
                <AlertCircle className="w-4 h-4" data-id="element-364" />
                Atención
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-charcoal" data-id="element-365">
                Esta oferta de $11.99 USD expira pronto.
              </h3>
              <p className="text-charcoal-light" data-id="element-366">
                El precio regresa a $15.99 USD una vez que termine el período de
                lanzamiento.
              </p>
            </div>

            <div className="flex-1 bg-white p-6 rounded-2xl shadow-sm border border-amber/30 w-full md:w-auto" data-id="element-367">
              <div className="flex items-center gap-4 mb-4" data-id="element-368">
                <div className="bg-amber/20 p-3 rounded-full" data-id="element-369">
                  <Users className="w-6 h-6 text-amber" data-id="element-370" />
                </div>
                <div data-id="element-371">
                  <p className="font-bold text-charcoal text-lg" data-id="element-372">47 padres</p>
                  <p className="text-sm text-charcoal-light" data-id="element-373">
                    ya accedieron al plan esta semana.
                  </p>
                </div>
              </div>
              <div className="border-t border-cream-dark pt-4 mt-2" data-id="element-374">
                <p className="text-terracotta font-medium flex items-center gap-2 justify-center md:justify-start" data-id="element-375">
                  <Clock className="w-5 h-5" data-id="element-376" />
                  Cada día que pasa sin un sistema claro es otro berrinche que
                  pudo haberse evitado.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}